import { useMediaQuery } from "@mui/material";

const useDesktopOrMobileDevice = () => {
    return {
      isMobileDevice: !useMediaQuery("@media (pointer: fine)"),
      isDesktopDevice: useMediaQuery("@media (pointer: fine)"),
    };
  };
  
  export default useDesktopOrMobileDevice;